/* eslint-disable no-shadow */
import actions from "./actions"
import mutations from "./mutations"

const state = () => ({
  conditionsBeingActivated: {},
})

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
}

export default module
